export const singlePurchaseBankInfoConstants = {
    SINGLE_PURCHASE_STORE_BANK_INFO_COLLECTED: 'SINGLE_PURCHASE_STORE_BANK_INFO_COLLECTED',
    SINGLE_PURCHASE_CLEAR_BANK_INFO: 'SINGLE_PURCHASE_CLEAR_BANK_INFO',
    SET_BANK_ID_FOR_SINGLE_PURCHASE: 'SET_BANK_ID_FOR_SINGLE_PURCHASE',
    SINGLE_PURCHASE_SET_BANK_FORM_OPEN: 'SINGLE_PURCHASE_SET_BANK_FORM_OPEN',
    SINGLE_PURCHASE_CLEAR_BANK_FORM_OPEN: 'SINGLE_PURCHASE_CLEAR_BANK_FORM_OPEN'
}